<bn-loading-overlay></bn-loading-overlay>

<div class="container" [formGroup]="atualizacaoForm" *ngIf="atualizacaoForm; else carregando">

    <div class="row">
        <div class="col">
            <h3>Atualizacao Informação de Risco Operação <small class="text-muted">(#ID: {{ idAtualizacao }})</small></h3>
        </div>

        <div class="col-auto">
            <button class="btn btn-primary" type="button" (click)="voltar()">Voltar</button>
        </div>
    </div>


    <div class="row">
        <div class="bn-form-group col-md-6">
            <label><b>Agente financeiro</b></label>
            <select name="cnpjAgenteFinanceiro" formControlName="cnpjAgenteFinanceiro" class="form-select">
                <option [value]=null>Todos</option>
                <option *ngFor="let agente of agentesFinanceiros" [value]="agente.cnpj">{{agente.nome}}</option>
            </select>
        </div>

        <div class="bn-form-group col-md-3">
            <label><b>Status do Protocolo</b></label>
            <input type="text" class="form-control" name="statusProtocolo" formControlName="statusProtocolo" />
        </div>

        <div class="bn-form-group col-md-3">
            <label><b>Data de Envio</b></label>
            <input type="text" class="form-control" name="dataEnvio" formControlName="dataEnvio" />
        </div>

    </div>

    <div class="row">
        <div class="bn-form-group col-md-3">
            <label><b>Id. Operação</b></label>
            <input type="text" class="form-control" name="idOperacao" formControlName="idOperacao" />
        </div>

        <div class="col-md-3">
            <label><b>Sistema: </b> <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                    ngbTooltip="Sistema do contrato, constante dos Boletos de Cobrança enviados pelo BNDES, ou Crédito Livre."></i>
            </label>
            <select class="form-select" name="sistemaCobranca" formControlName="sistemaCobranca">
                <option value=null>Crédito Livre</option>
                <option value='15'>15 - Contratos FINAME</option>
                <option value='89'>89 - Contratos BNDES</option>
            </select>
        </div>

        <div class="col-md-3">
            <label><b>Id. externo operação: </b> <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                    ngbTooltip="Identificador da operação informado pelo Agente Financeiro em operações Crédito Livre."></i>
            </label>
            <input type="text" class="form-control" name="idExternoOperacao" formControlName="idExternoOperacao">
        </div>

        <div class="col-md-3">
            <label><b>Contrato: </b> <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                    ngbTooltip="Número do contrato, constante dos Boletos de Cobrança enviados pelo BNDES."></i>
            </label>
            <input type="text" class="form-control" name="contrato" formControlName="contrato">
        </div>
    </div>
    
    <div class="row">
        
        <div class="bn-form-group col-md-7">
            <label><b>Status do Protocolo</b></label>
            <input type="text" class="form-control" name="statusProtocolo" formControlName="statusProtocolo" />
        </div>
         
        <div class="bn-form-group col-md-3">
            <label><b>Risco da Operação/ Perda Esperada</b></label>
            <input type="text" class="form-control" name="riscoOperacao" formControlName="riscoOperacao" />
        </div>

        <div class="bn-form-group col-md-2">
            <label><b>liquidado</b></label>
            <input type="checkbox" class="form-check checkbox-gigante" name="liquidada" formControlName="liquidada" />
        </div>
        
    </div>

</div>

<div class="container row" *ngIf="ocorrencias?.length > 0">
    <div class="table-responsive">
        <table class="table-striped table-bordered">
            <thead>
                <tr>
                    <th class="text-center">Erro(s) encontrado(s)</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let ocorrencia of ocorrencias">
                    <td>{{ ocorrencia.mensagem }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<ng-template #carregando>
    <div class="loading-pesquisa">
        <i class="bn-loading"></i>
    </div>
</ng-template>